import { NextSeo } from "next-seo";
import { SEO } from "@/constants/index";
import { GenericSport } from "@/graphql/gql/graphql";

type SportSeoProps = {
  sport: Partial<GenericSport>;
  definedUrl?: string;
};

const SportSeo = ({ sport, definedUrl }: SportSeoProps) => {
  const { name, seo, slug } = sport;
  const url = definedUrl ?? `${SEO.FANDUEL_URL_RESEARCH}/${slug}`;
  const image = seo?.image?.url;
  const images = image
    ? {
        images: [
          {
            width: 800,
            height: 600,
            alt: "Og Image Alt",
            type: "image/jpeg",
            url: image,
          },
        ],
      }
    : {};

  return (
    <NextSeo
      title={seo?.title ?? name}
      description={seo?.description ?? ""}
      canonical={seo?.canonicalUrl ?? url}
      noindex={!!seo?.noIndex}
      openGraph={{
        url,
        description: seo?.description ?? "",
        ...images,
      }}
      twitter={{
        cardType: "summary_large_image",
      }}
    />
  );
};
export default SportSeo;
